import { cloneDeep } from 'lodash'
import { ToastProgrammatic as Toast } from 'buefy'

const defaultState = {
  current: null
}

export const state = () => cloneDeep(defaultState)

export const getters = {
  current(state) {
    return state.current
  }
}

export const mutations = {
  current(state, current) {
    state.current = current
  }
}

export const actions = {
  async getById({ commit }, id) {
    const result = await this.$coreApi.$get(`athletes/athlete_data_changes/${id}`)

    commit('current', result.data)
  },
  async getLastPendingAcknowledge({ commit }, params) {
    await this.$coreApi
      .$get('athletes/athlete_data_changes/last_pending_acknowledge', {
        params
      })
      .then(result => {
        commit('current', result.data)
      })
      .catch(error => {
        if (error.response.status === 404) return commit('current', null)

        throw error
      })
  },
  async cancel({ commit, state }, athleteDataChangeId) {
    await this.$coreApi
      .$post(`athletes/athlete_data_changes/${athleteDataChangeId}/cancel`)
      .then(() => {
        this.$router.push(
          this.app.localePath({
            name: '/'
          })
        )

        Toast.open({
          duration: 5000,
          message: this.$i18n.t('domain.athleteDataChange.canceledNotification'),
          position: 'is-top',
          type: 'is-success'
        })
      })
      .catch(() => {
        Toast.open({
          duration: 5000,
          message: this.$i18n.t('domain.athleteDataChange.errors.onCancel'),
          position: 'is-top',
          type: 'is-danger'
        })
      })
  }
}
